import Config from 'services/config/local';

/**
 * HttpInterceptor class.
 * Use it to extend request or response made by $http service.
 */
export default class HttpInterceptor {
    /**
     * Request modifier
     * @param {Object} requestConfig - Request configuration
     * @returns {Object}
     */
    request(requestConfig) { // eslint-disable-line class-methods-use-this
        // if (Config.api.apiKey) {
        //     requestConfig.headers['Authorization'] = Config.api.apiKey;
        // }

        if (requestConfig && requestConfig.url && requestConfig.url.startsWith('/v1/')) {
            requestConfig.url = Config.api.baseUrl + requestConfig.url; // eslint-disable-line no-param-reassign
        }

        return requestConfig;
    }
}



// WEBPACK FOOTER //
// ./app/services/interceptors/http.class.js